import { observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../../i18n/globalTranslations';
import PickUpPointModel from '../../../../models/shipping/PickupPoint';
import { modelOf } from '../../../../prop-types';

const PickupPoint = ({ info }) => {
  const { name, opening_hours, address, distance } = info;

  return (
    <div className="PickupPoint">
      <p className="PickupPoint__name">{name}</p>
      {address && (
        <p className="PickupPoint__address">
          {address}{' '}
          {distance && (
            <span>
              (
              <FormattedMessage
                {...globalTranslations.distanceLabel}
                values={{
                  value: distance,
                }}
              />
              )
            </span>
          )}
        </p>
      )}
      {opening_hours && (
        <p className="PickupPoint__opening-hours">
          <FormattedMessage
            {...globalTranslations.openingHours}
            values={{
              value: opening_hours,
            }}
          />
        </p>
      )}
    </div>
  );
};

PickupPoint.propTypes = {
  info: modelOf(PickUpPointModel).isRequired,
};

export default observer(PickupPoint);
